import React, { useContext } from 'react';
import { StateContext } from '../../StateContext';
import { useLanguage } from '../../Services/LanguageContext';
import { getProjectTypeLabel } from '../../Services/types';

const ActivityFeed = () => {
    const { loginData } = useContext(StateContext);
    const { t, language } = useLanguage();

    const projects = loginData?.projects ?? [];

    const sorted = [...projects]
        .sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime())
        .slice(0, 40);

    const formatDate = (date: Date | string) =>
        new Date(date).toLocaleDateString(language === 'nl' ? 'nl-NL' : 'en-GB', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });

    if (sorted.length === 0) {
        return <div className='admin-empty'>{t('noDataAvailable')}</div>;
    }

    return (
        <div className='activity-list'>
            {sorted.map(project => (
                <div key={project.id} className='activity-row'>
                    <div className='activity-dot' />
                    <div className='activity-content'>
                        <div className='activity-name'>{project.name}</div>
                        <div className='activity-meta'>
                            {project.type !== undefined && project.type !== null && (
                                <span>{getProjectTypeLabel(project.type, language)}</span>
                            )}
                            {project.createdByUserName && (
                                <span>
                                    {project.type !== undefined && project.type !== null ? ' · ' : ''}
                                    {t('createdBy')}: <strong>{project.createdByUserName}</strong>
                                </span>
                            )}
                        </div>
                    </div>
                    <div className='activity-date'>{formatDate(project.created)}</div>
                </div>
            ))}
        </div>
    );
};

export default ActivityFeed;
